import { BiSearch } from "react-icons/bi";
import { Input } from "../Input";

function SearchInput({
  value,
  setter,
  placeholder = "Search",
  customStyle,
  inputStyle,
  iconColor = "var(--search-icon-color)",
}) {
  return (
    <Input
      setter={setter}
      value={value}
      type="text"
      customStyle={{
        borderRadius: "var(--input-border-radius)",
        height: "100%",
        width: "100%",
        border: "1px solid var(--input-border-color) ",
        ...customStyle,
      }}
      inputStyle={{
        padding: "8px 44px 8px 12px",
        // the wrapper adds a 1px border each side: 38 + 2 = 40, like Input
        height: "38px",
        fontSize: "var(--fs-100)",
        border: "none",
        backgroundColor: "var(--white-color)",
        borderRadius: "var(--input-border-radius)",
        ...inputStyle,
      }}
      placeholder={placeholder}
      name={`search-input-${Math.random()}`}
      autoComplete="off"
      rightIcon={
        <BiSearch
          size={18}
          color={iconColor}
          style={{ display: "block", position: "relative", top: "-2px" }}
        />
      }
    />
  );
}

export default SearchInput;
